module.exports = "<div class=\"item\">\n    <div class=\"row text-center text-large text-strong\">\n        <div class=\"col\" translate>\n            CHART_RESOURCE_WORKLOAD\n        </div>\n    </div>\n\n    <div class=\"chart-no-data\" ng-if=\"$ctrl.workloads.length == 0\" translate>\n        CHART_RESOURCE_WORKLOAD_NO_DATA\n    </div>\n\n    <div id=\"chart-resource-workload-hs\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/chart-resource-workload/chart-resource-workload.html
// module id = 819
// module chunks = 0